import { render, staticRenderFns } from "./RecursivePayloadOnSchemaEditor.vue?vue&type=template&id=582e7f1c&scoped=true&"
import script from "./RecursivePayloadOnSchemaEditor.vue?vue&type=script&lang=js&"
export * from "./RecursivePayloadOnSchemaEditor.vue?vue&type=script&lang=js&"
import style0 from "./RecursivePayloadOnSchemaEditor.vue?vue&type=style&index=0&id=582e7f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e7f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VRow,VSelect,VTextField,VTooltip})
